<template>
    <div class="w-full flex flex-column gap-3">
        <MobMenu :headerTxt="lang('user_title')"
            :footerTxt="lang('user_description')"
            :items=[]>
            <template v-slot:body>
                <Fullname />
                <Email />
                <Phone />
                <Password />
            </template>
        </MobMenu>
    </div>    
</template>


<script>
import MobMenu from             '@/components/sides/menu/MobMenu.vue' 
import Fullname from            '@/components/personal/profile/Fullname.vue'
import Email from               '@/components/personal/profile/Email.vue'
import Phone from               '@/components/personal/profile/Phone.vue'
import Password from            '@/components/personal/profile/Password.vue'

export default {
    data(){
        return{
            
        }
    },
    components: {
        MobMenu,
        Fullname,
        Email,
        Phone,
        Password
    },
    methods:{
        lang(value){
            return this.$t(`views.personal.profile.${value}`)
        },
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
}
</script>